import type { ZudokuConfig } from "zudoku";

// Build the config object
const config: ZudokuConfig = {
  basePath: "/docs",
  site: {
    logo: {
      src: { light: "/docs/logo-light.svg", dark: "/docs/logo-dark.svg" },
      alt: "LeadsDB",
      width: "130px",
    },
  },
  // Clerk authentication disabled due to compatibility issues
  // TODO: Re-enable when Zudoku Clerk integration is stable
  navigation: [
    {
      type: "link",
      to: "/introduction",
      label: "Introduction",
      icon: "book",
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
      icon: "folder-cog",
    },
    {
      type: "link",
      to: "/mcp",
      label: "MCP Setup",
      icon: "settings",
    },
    {
      type: "link",
      to: "/sdks",
      label: "SDKs",
      icon: "code",
    },
    {
      type: "link",
      to: "/changelog",
      label: "Changelog",
      icon: "list",
    },
    {
      type: "link",
      to: "/faq",
      label: "FAQ",
      icon: "help-circle",
    },
  ],
  redirects: [{ from: "/", to: "/introduction" }],
  apis: [
    {
      type: "file",
      // This file is copied from webapp/swagger-ui/swagger.yaml during build
      input: "./apis/openapi.yaml",
      path: "/api",
    },
  ],
};

// Note: API Identity plugin removed due to Zudoku provider context issues
// TODO: Re-add when Zudoku fixes the provider context issue

export default config;
